module.exports = __webpack_public_path__ + "img/ic_add_rounded.5353f23b.svg";